import React from "react";
import { useTranslation } from "react-i18next";

// common
import {
  ModalText,
  ModalLayout,
  LargeModalStyling,
  MoreModalButtons,
} from "common/modal";

const { LargeModal } = LargeModalStyling;
const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ButtonContainer } = MoreModalButtons;

type NoClassToBookModalProps = {
  visible: boolean;
  onCloseModal: () => void;
  nextCourseId?: number;
  setCourseFromLocationId?: (id: number) => void;
};

const NoClassToBookModal = ({
  visible,
  onCloseModal,
  nextCourseId,
  setCourseFromLocationId,
}: NoClassToBookModalProps) => {
  const { t } = useTranslation("book_a_class");
  const navigateToCourse = () => {
    if (nextCourseId && setCourseFromLocationId) {
      setCourseFromLocationId(nextCourseId);
    }
  };
  return (
    <LargeModal
      title="No Class Left To Book"
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t("In this course there are no classes left that you can still book.")}{" "}
        {nextCourseId && t("You can book the next level Follow On Course")}{" "}
        {nextCourseId}{" "}
        {nextCourseId && t("or any other course in this level instead.")}
      </ConfirmationText>
      <ModalRow gutter={24}>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonYellow
            type="primary"
            onClick={() => {
              onCloseModal();
            }}
          >
            {t("Book other course")}
          </ModalButtonYellow>
        </ButtonContainer>
        {nextCourseId && (
          <ButtonContainer xs={20} sm={20} md={12}>
            <ModalButtonYellow
              type="primary"
              onClick={() => {
                navigateToCourse();
                onCloseModal();
              }}
            >
              {t("Follow On Course")}
            </ModalButtonYellow>
          </ButtonContainer>
        )}
      </ModalRow>
    </LargeModal>
  );
};

export default NoClassToBookModal;
